import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const sendEmailTemplateService = ({ emails, content }) => {
  return http.post(`/communication/sendmail`, { emails, content });
};

const createClientGroupBroadcast = (data: any) => {
  return http.post("communication/create-client-group", data);
};

const getClientGroupBroadcast = ({ queryKey }: any) => {
  const [, params] = queryKey;
return http.get("/communication/get-client-group", { params });
};

const deleteClientGroupBroadcast = (id: number) => {
  return http.delete(`/communication/delete-client-group/${id}`);
};


const updateClientGroupBroadcast = ({ id, data }: any) => {
  return http.put(`/communication/update-client-group/${id}`, data);
};

const addClientsToClientGroup = ({ id, data }: any) => {
  return http.put(`/communication/add-clients-to-clientgroup/${id}`, data);
};

const removeClientsFromClientGroup = ({ id, data }: any) => {
  return http.put(`/communication/remove-clients-from-clientgroup/${id}`, data);
};

// const getClientGroupBroadcastDetails = (id:any) => {
//   return http.get(`/communication/get-client-groupdetails/${id}`);
// };
const getClientGroupBroadcastDetails = ({ queryKey }: any) => {
  const [_, id, search] = queryKey; 
  return http.get(`/communication/get-client-groupdetails/${queryKey[1].id}`,{ params: { ...queryKey[1] } });
};


const createEmailTemplatessss = (data: any) => {
  return http.post("communication/create-email-template", data);
};

const getEmailTemplates = ({ queryKey }: any) => {
  const [, params] = queryKey;
return http.get("/communication/get-email-template", { params });
};

const deleteEmailTemplate = (id: number) => {
  return http.delete(`/communication/delete-email-template/${id}`);
};

const getOneEmailTemplate = (id:any) => {
  return http.get(`/communication/get-one-emailTemplate/${id}`);
};

const updateEmailTemplate = ({ id, data }: any) => {
  return http.put(`/communication/update-email-temlate/${id}`, data);
};
const createBroadcastActivity = (data: any) => {
  return http.post("communication/create-broadcast-activity", data);
};

const deleteBroadcastActivity = (id: number) => {
  return http.delete(`/communication/delete-broadcast-activity/${id}`);
};

const updateBroadcastActivity = ({ id, data }: any) => {
  return http.put(`/communication/update-broadcast-activity/${id}`, data);
};

const uploadFileBroadcast = (data: any) => {
  return http.post("communication/upload-files", data);
};

const getBroadcastActivity = ({ queryKey }: any) => {
  const [, params] = queryKey;
  return http.get("communication/get-brocastactivity", { params });
};

const getBroadcastActivityDetails = ({ queryKey }: any) => {
  const [_, id, search] = queryKey;
  return http.get(`/communication/get-broadcastactivity/${queryKey[1].id}`,{ params: { ...queryKey[1] } });
};

const getBroadcastRunHistory = ({ queryKey }: any) => {
  const [, params] = queryKey;
  return http.get(`/communication/broadcast-run-history/${params.id}`, { params });
};


const getFilteredClients = ({ queryKey }: any) => {
  return http.get(`/communication/get-filtered-clients/${queryKey[1].id}`,{ params: { ...queryKey[1] } });
};

const getWhatsappConversationData = ({ queryKey }: any) => {
  console.log('message', queryKey);
  const [, params] = queryKey; // index 1 contains the search params
  return http.get('whatsapp/conversation', { params });
};


const sendMessageConversation = (data: any) => {
  return http.post("whatsapp/sendWhatsappMessage", data);
};

const createMetaTemplate = (data: any) => {
  return http.post("whatsapp/createMetaTemplate", data);
};

const getAllMetaTemplates = (data: any) => {
  return http.get("whatsapp/allApprovedTemplates", data);
};

const sendTemplateMessageWithSelectedTemplate =(data:any) =>{
  return http.post("whatsapp/sendTemplateMessageWithSelectedTemplate", data);

}

const getDefaultMetaTemplates = (data: any) => {
  return http.get("whatsapp/default-meta-templates", data);
};
const getConversationClients = () => {
  return http.get("whatsapp/get-conversation-clients");
};


export {
  sendEmailTemplateService,
  createClientGroupBroadcast,
  getClientGroupBroadcast,
  deleteClientGroupBroadcast,
  updateClientGroupBroadcast,
  getClientGroupBroadcastDetails,
  createEmailTemplatessss,
  getOneEmailTemplate,
  updateEmailTemplate,
  getEmailTemplates,
  deleteEmailTemplate,
  createBroadcastActivity,
  deleteBroadcastActivity,
  updateBroadcastActivity,
  getBroadcastActivity,
  uploadFileBroadcast,
  getBroadcastActivityDetails,
  getBroadcastRunHistory,
  getFilteredClients,
  addClientsToClientGroup,
  removeClientsFromClientGroup,
  getWhatsappConversationData,
  sendMessageConversation,
  createMetaTemplate,
  getAllMetaTemplates,
  sendTemplateMessageWithSelectedTemplate,
  getDefaultMetaTemplates,
  getConversationClients
};
